/* FLEX-WOOD® — konfigurator żaluzji tarasowych (Shopify)
 * -------------------------------------------------------------------
 * Katalog: 23 produkty (+2 B-Ware pomijane), dopasowanie po SKU.
 *   FW-SM-{K}        mechanizm stalowy
 *   FW-MA-{K}        mechanizm aluminiowy
 *   FW-V-{K}         mechanizm VERT
 *   FW-2-M-{K}       mechanizm B-Ware (pomijany)
 *   FW-DL-{K}-{LEN}  lamela drewniana
 *   FW-AL-{K}-{LEN}  lamela aluminiowa
 * Kody koloru: G anthracite | C black | B brown | BI white | Z oak
 *              N natur | W winchester | AB abachi
 *
 * Ceny, kolory i długości pochodzą WYŁĄCZNIE z katalogu Shopify.
 * Skrypt liczy tylko ilości i geometrię.
 */
(function () {
  'use strict';

  var ROOT = document.querySelector('[data-fw-root]');
  var CATEL = document.querySelector('[data-fw-catalog]');
  if (!ROOT || !CATEL) return;

  var FEED = JSON.parse(CATEL.textContent);

  /* ---------------------------------------------------------------
   * Dane konstrukcyjne (arkusz "zwymiarowane mechanizmy")
   * indeks = liczba lameli, wartość = wymiar w cm
   * --------------------------------------------------------------- */
  var PITCH = {
    flex: [0, 10, 19, 28, 37, 46, 55, 64, 72.5, 81.5, 90.5, 99, 108, 117, 126, 135, 144, 153, 161.5, 170.5, 179.5, 188.5, 197, 206, 215, 224, 233, 242, 251, 260, 269, 278, 287, 295, 304, 313, 322],
    vert: [0, 10.5, 19.5, 28.5, 37.5, 46.5, 55, 64, 73, 82, 91, 99.5, 108.5, 117.5, 126.5, 135.5, 144.5, 153, 162, 171, 180, 188.5, 197.5, 206.5, 215.5, 224, 232.5, 241.5, 250.5, 259.5, 268, 277, 286, 294.5, 303, 311.5, 320]
  };

  var CAP = 12; // maks. lameli na jeden mechanizm

  var MECH_COLORS = {
    black:      { base: '#1c1c1e', hi: 'rgba(255,255,255,.16)', lo: 'rgba(0,0,0,.35)' },
    anthracite: { base: '#383b3f', hi: 'rgba(255,255,255,.18)', lo: 'rgba(0,0,0,.32)' },
    white:      { base: '#e7e4dd', hi: 'rgba(255,255,255,.6)',  lo: 'rgba(0,0,0,.14)' },
    brown:      { base: '#5b4632', hi: 'rgba(255,255,255,.14)', lo: 'rgba(0,0,0,.34)' }
  };
  var SLAT_COLORS = {
    natur:      { base: '#d9b277', grain: '#c49a57' },
    oak:        { base: '#b3743a', grain: '#8d5a2a' },
    winchester: { base: '#c9a06a', grain: '#ab8250' },
    abachi:     { base: '#a9743f', grain: '#8b5c30' },
    white:      { base: '#ece8e1', grain: '#dad4ca' },
    anthracite: { base: '#3f4347', grain: '#33373a' },
    black:      { base: '#26272a', grain: '#191a1c' }
  };

  // kolejność wyświetlania; cokolwiek spoza listy ląduje na końcu
  var MECH_COLOR_ORDER = ['black', 'anthracite', 'white', 'brown'];
  var SLAT_COLOR_ORDER = ['natur', 'oak', 'winchester', 'abachi', 'white', 'anthracite', 'black'];

  var T = {
    pl: {
      tagline: 'Konfigurator żaluzji tarasowych', tilt: 'Nachylenie lameli', closed: 'Zamknięte', open: 'Otwarte', openClose: ['Otwórz', 'Zamknij'], per: 'szt.',
      s0: 'System', s1: 'Wymiary otworu', width: 'Szerokość', height: 'Wysokość', slatLen: 'Długość lameli',
      s2: 'Mechanizm', s3: 'Lamele', color: 'Kolor', finish: 'Wykończenie',
      steel: 'Stalowy', alu: 'Aluminiowy', vert: 'VERT alu', wood: 'Drewno', aluS: 'Aluminium',
      sysFlex: 'FLEX-WOOD®', sysFlexSub: 'Lamele poziome', sysVert: 'FLEX-WOOD® VERT', sysVertSub: 'Lamele pionowe',
      hintFlex: 'Mechanizm z rączką montowany pionowo po bokach. Klasyczny układ do zabudowy tarasu i pergoli.',
      hintVert: 'Bezrączkowy mechanizm aluminiowy montowany poziomo — jedna listwa steruje wszystkimi lamelami. Sztywniejszy układ do dużych powierzchni i miejsc wietrznych.',
      lenHintFlex: 'Lamele biegną w poziomie — długość dzieli szerokość otworu na przęsła.',
      lenHintVert: 'Lamele stoją pionowo — długość dzieli wysokość otworu na pasy.',
      oneLen: 'W tym kolorze dostępna jest tylko jedna długość lameli.',
      withHandle: 'z rączką', noHandle: 'bez rączki',
      summary: 'PODSUMOWANIE', mechs: 'Mechanizmy', slatsN: 'Lamele', built: 'Wymiar zabudowy', coverage: 'Powierzchnia otworu', total: 'Razem',
      addToCart: 'Dodaj do koszyka', adding: 'Dodaję…', added: '✓ Dodano do koszyka', unavailable: 'Chwilowo niedostępne',
      note: 'System modułowy — mechanizmy łączysz w dowolną szerokość. Ceny z katalogu sklepu.',
      missing: 'Brak wariantu w sklepie dla:', cartError: 'Nie udało się dodać do koszyka:',
      noProducts: 'Sekcja nie ma przypisanego katalogu — wskaż produkty FLEX-WOOD w edytorze motywu.',
      colors: { black: 'Czarny', anthracite: 'Antracyt', white: 'Biały', brown: 'Brązowy', natur: 'Sosna natur', oak: 'Złoty dąb', winchester: 'Winchester', abachi: 'Abachi termo' }
    },
    de: {
      tagline: 'Terrassen-Jalousie Konfigurator', tilt: 'Lamellenneigung', closed: 'Geschlossen', open: 'Offen', openClose: ['Öffnen', 'Schließen'], per: 'Stk.',
      s0: 'System', s1: 'Maße der Öffnung', width: 'Breite', height: 'Höhe', slatLen: 'Lamellenlänge',
      s2: 'Mechanismus', s3: 'Lamellen', color: 'Farbe', finish: 'Oberfläche',
      steel: 'Stahl', alu: 'Aluminium', vert: 'VERT Alu', wood: 'Holz', aluS: 'Aluminium',
      sysFlex: 'FLEX-WOOD®', sysFlexSub: 'Horizontale Lamellen', sysVert: 'FLEX-WOOD® VERT', sysVertSub: 'Vertikale Lamellen',
      hintFlex: 'Mechanismus mit Griff, seitlich vertikal montiert. Der Klassiker für Terrasse und Pergola.',
      hintVert: 'Grifflos, Aluminium, horizontal montiert — eine Leiste steuert alle Lamellen. Stabiler für große und windige Flächen.',
      lenHintFlex: 'Lamellen liegen waagerecht — die Länge teilt die Breite in Felder.',
      lenHintVert: 'Lamellen stehen senkrecht — die Länge teilt die Höhe in Bänder.',
      oneLen: 'In dieser Farbe ist nur eine Lamellenlänge verfügbar.',
      withHandle: 'mit Griff', noHandle: 'grifflos',
      summary: 'ZUSAMMENFASSUNG', mechs: 'Mechanismen', slatsN: 'Lamellen', built: 'Aufbaumaß', coverage: 'Fläche der Öffnung', total: 'Gesamt',
      addToCart: 'In den Warenkorb', adding: 'Wird hinzugefügt…', added: '✓ Hinzugefügt', unavailable: 'Derzeit nicht verfügbar',
      note: 'Modulares System — Mechanismen für jede Breite kombinierbar. Preise aus dem Shop-Katalog.',
      missing: 'Keine Variante im Shop für:', cartError: 'Hinzufügen fehlgeschlagen:',
      noProducts: 'Der Sektion ist kein Katalog zugewiesen — FLEX-WOOD Produkte im Theme-Editor wählen.',
      colors: { black: 'Schwarz', anthracite: 'Anthrazit', white: 'Weiß', brown: 'Braun', natur: 'Kiefer natur', oak: 'Goldeiche', winchester: 'Winchester', abachi: 'Abachi Thermo' }
    },
    en: {
      tagline: 'Terrace louvre configurator', tilt: 'Slat tilt', closed: 'Closed', open: 'Open', openClose: ['Open', 'Close'], per: 'pc.',
      s0: 'System', s1: 'Opening size', width: 'Width', height: 'Height', slatLen: 'Slat length',
      s2: 'Mechanism', s3: 'Slats', color: 'Colour', finish: 'Finish',
      steel: 'Steel', alu: 'Aluminium', vert: 'VERT alu', wood: 'Wood', aluS: 'Aluminium',
      sysFlex: 'FLEX-WOOD®', sysFlexSub: 'Horizontal slats', sysVert: 'FLEX-WOOD® VERT', sysVertSub: 'Vertical slats',
      hintFlex: 'Mechanism with a handle, mounted vertically on the sides. The classic terrace and pergola build-up.',
      hintVert: 'Handleless aluminium mechanism mounted horizontally — one rail drives every slat. Stiffer for large, windy spans.',
      lenHintFlex: 'Slats run horizontally — the length splits the opening width into bays.',
      lenHintVert: 'Slats stand vertically — the length splits the opening height into bands.',
      oneLen: 'Only one slat length is available in this colour.',
      withHandle: 'with handle', noHandle: 'handleless',
      summary: 'SUMMARY', mechs: 'Mechanisms', slatsN: 'Slats', built: 'Built size', coverage: 'Opening area', total: 'Total',
      addToCart: 'Add to cart', adding: 'Adding…', added: '✓ Added to cart', unavailable: 'Currently unavailable',
      note: 'Modular system — combine mechanisms for any width. Prices from the shop catalogue.',
      missing: 'No shop variant for:', cartError: 'Could not add to cart:',
      noProducts: 'No catalogue assigned to this section — pick the FLEX-WOOD products in the theme editor.',
      colors: { black: 'Black', anthracite: 'Anthracite', white: 'White', brown: 'Brown', natur: 'Natural pine', oak: 'Golden oak', winchester: 'Winchester', abachi: 'Thermo abachi' }
    },
    fr: {
      tagline: 'Configurateur de stores de terrasse', tilt: 'Inclinaison des lames', closed: 'Fermé', open: 'Ouvert', openClose: ['Ouvrir', 'Fermer'], per: 'pce',
      s0: 'Système', s1: "Dimensions de l'ouverture", width: 'Largeur', height: 'Hauteur', slatLen: 'Longueur des lames',
      s2: 'Mécanisme', s3: 'Lames', color: 'Couleur', finish: 'Finition',
      steel: 'Acier', alu: 'Aluminium', vert: 'VERT alu', wood: 'Bois', aluS: 'Aluminium',
      sysFlex: 'FLEX-WOOD®', sysFlexSub: 'Lames horizontales', sysVert: 'FLEX-WOOD® VERT', sysVertSub: 'Lames verticales',
      hintFlex: 'Mécanisme à poignée, monté verticalement sur les côtés. La configuration classique pour terrasse et pergola.',
      hintVert: "Mécanisme aluminium sans poignée, monté horizontalement — une seule tringle commande toutes les lames. Plus rigide pour les grandes surfaces exposées au vent.",
      lenHintFlex: "Les lames sont horizontales — la longueur divise la largeur de l'ouverture en travées.",
      lenHintVert: "Les lames sont verticales — la longueur divise la hauteur de l'ouverture en bandes.",
      oneLen: 'Une seule longueur de lame est disponible dans ce coloris.',
      withHandle: 'avec poignée', noHandle: 'sans poignée',
      summary: 'RÉCAPITULATIF', mechs: 'Mécanismes', slatsN: 'Lames', built: 'Dimensions réalisées', coverage: "Surface de l'ouverture", total: 'Total',
      addToCart: 'Ajouter au panier', adding: 'Ajout en cours…', added: '✓ Ajouté au panier', unavailable: 'Momentanément indisponible',
      note: 'Système modulaire — combinez les mécanismes pour toute largeur. Prix issus du catalogue de la boutique.',
      missing: 'Aucune variante en boutique pour :', cartError: "Impossible d'ajouter au panier :",
      noProducts: "Aucun catalogue associé à cette section — sélectionnez les produits FLEX-WOOD dans l'éditeur de thème.",
      colors: { black: 'Noir', anthracite: 'Anthracite', white: 'Blanc', brown: 'Brun', natur: 'Pin naturel', oak: 'Chêne doré', winchester: 'Winchester', abachi: 'Abachi thermo' }
    },
    it: {
      tagline: 'Configuratore persiane da terrazza', tilt: 'Inclinazione lamelle', closed: 'Chiuso', open: 'Aperto', openClose: ['Apri', 'Chiudi'], per: 'pz',
      s0: 'Sistema', s1: "Misure dell'apertura", width: 'Larghezza', height: 'Altezza', slatLen: 'Lunghezza lamelle',
      s2: 'Meccanismo', s3: 'Lamelle', color: 'Colore', finish: 'Finitura',
      steel: 'Acciaio', alu: 'Alluminio', vert: 'VERT alu', wood: 'Legno', aluS: 'Alluminio',
      sysFlex: 'FLEX-WOOD®', sysFlexSub: 'Lamelle orizzontali', sysVert: 'FLEX-WOOD® VERT', sysVertSub: 'Lamelle verticali',
      hintFlex: 'Meccanismo con maniglia, montato verticalmente ai lati. La soluzione classica per terrazzi e pergole.',
      hintVert: "Meccanismo in alluminio senza maniglia, montato in orizzontale — un'unica barra comanda tutte le lamelle. Più rigido per superfici ampie ed esposte al vento.",
      lenHintFlex: "Le lamelle sono orizzontali — la lunghezza divide la larghezza dell'apertura in campate.",
      lenHintVert: "Le lamelle sono verticali — la lunghezza divide l'altezza dell'apertura in fasce.",
      oneLen: 'In questo colore è disponibile una sola lunghezza di lamella.',
      withHandle: 'con maniglia', noHandle: 'senza maniglia',
      summary: 'RIEPILOGO', mechs: 'Meccanismi', slatsN: 'Lamelle', built: 'Misura realizzata', coverage: "Superficie dell'apertura", total: 'Totale',
      addToCart: 'Aggiungi al carrello', adding: 'Aggiunta in corso…', added: '✓ Aggiunto al carrello', unavailable: 'Al momento non disponibile',
      note: 'Sistema modulare — combina i meccanismi per qualsiasi larghezza. Prezzi dal catalogo del negozio.',
      missing: 'Nessuna variante in negozio per:', cartError: 'Impossibile aggiungere al carrello:',
      noProducts: "Nessun catalogo assegnato a questa sezione — seleziona i prodotti FLEX-WOOD nell'editor del tema.",
      colors: { black: 'Nero', anthracite: 'Antracite', white: 'Bianco', brown: 'Marrone', natur: 'Pino naturale', oak: 'Rovere dorato', winchester: 'Winchester', abachi: 'Abachi termo' }
    },
    es: {
      tagline: 'Configurador de celosías para terraza', tilt: 'Inclinación de las lamas', closed: 'Cerrado', open: 'Abierto', openClose: ['Abrir', 'Cerrar'], per: 'ud.',
      s0: 'Sistema', s1: 'Medidas del hueco', width: 'Ancho', height: 'Alto', slatLen: 'Longitud de las lamas',
      s2: 'Mecanismo', s3: 'Lamas', color: 'Color', finish: 'Acabado',
      steel: 'Acero', alu: 'Aluminio', vert: 'VERT alu', wood: 'Madera', aluS: 'Aluminio',
      sysFlex: 'FLEX-WOOD®', sysFlexSub: 'Lamas horizontales', sysVert: 'FLEX-WOOD® VERT', sysVertSub: 'Lamas verticales',
      hintFlex: 'Mecanismo con manilla, montado en vertical en los laterales. La configuración clásica para terrazas y pérgolas.',
      hintVert: 'Mecanismo de aluminio sin manilla, montado en horizontal: una sola barra acciona todas las lamas. Más rígido para superficies grandes y expuestas al viento.',
      lenHintFlex: 'Las lamas van en horizontal: la longitud divide el ancho del hueco en tramos.',
      lenHintVert: 'Las lamas van en vertical: la longitud divide el alto del hueco en franjas.',
      oneLen: 'En este color solo hay una longitud de lama disponible.',
      withHandle: 'con manilla', noHandle: 'sin manilla',
      summary: 'RESUMEN', mechs: 'Mecanismos', slatsN: 'Lamas', built: 'Medida construida', coverage: 'Superficie del hueco', total: 'Total',
      addToCart: 'Añadir al carrito', adding: 'Añadiendo…', added: '✓ Añadido al carrito', unavailable: 'No disponible por el momento',
      note: 'Sistema modular: combina mecanismos para cualquier ancho. Precios del catálogo de la tienda.',
      missing: 'No hay variante en la tienda para:', cartError: 'No se pudo añadir al carrito:',
      noProducts: 'Esta sección no tiene catálogo asignado: elige los productos FLEX-WOOD en el editor del tema.',
      colors: { black: 'Negro', anthracite: 'Antracita', white: 'Blanco', brown: 'Marrón', natur: 'Pino natural', oak: 'Roble dorado', winchester: 'Winchester', abachi: 'Abachi termo' }
    }
  };

  /* ---------------------------------------------------------------
   * Katalog — parsowanie SKU
   * --------------------------------------------------------------- */
  var SKU_COLOR = { G: 'anthracite', C: 'black', B: 'brown', BI: 'white', Z: 'oak', N: 'natur', W: 'winchester', AB: 'abachi' };

  function parseSku(sku) {
    var p = String(sku || '').toUpperCase().trim().split('-');
    if (p[0] !== 'FW') return null;
    if (p[1] === '2') return null;                       // B-Ware — poza konfiguratorem
    if (p.length === 3) {
      var mat = p[1] === 'SM' ? 'steel' : p[1] === 'MA' ? 'alu' : p[1] === 'V' ? 'vert' : null;
      var col = SKU_COLOR[p[2]];
      return mat && col ? { kind: 'mech', mat: mat, color: col } : null;
    }
    if (p.length === 4 && (p[1] === 'DL' || p[1] === 'AL')) {
      var c = SKU_COLOR[p[2]];
      var len = parseInt(p[3], 10);
      if (!c || !len) return null;
      return { kind: 'slat', mat: p[1] === 'DL' ? 'wood' : 'alu', color: c, len: len };
    }
    return null;
  }

  var CAT = { mech: {}, slat: {} };
  var UNMATCHED = 0;

  (FEED.variants || []).filter(Boolean).forEach(function (v) {
    var k = parseSku(v.sku);
    if (!k) { UNMATCHED++; return; }
    if (k.kind === 'mech') {
      CAT.mech[k.mat] = CAT.mech[k.mat] || {};
      if (!CAT.mech[k.mat][k.color]) CAT.mech[k.mat][k.color] = v;
    } else {
      CAT.slat[k.mat] = CAT.slat[k.mat] || {};
      CAT.slat[k.mat][k.color] = CAT.slat[k.mat][k.color] || {};
      if (!CAT.slat[k.mat][k.color][k.len]) CAT.slat[k.mat][k.color][k.len] = v;
    }
  });

  function ordered(keys, order) {
    var known = order.filter(function (k) { return keys.indexOf(k) >= 0; });
    var extra = keys.filter(function (k) { return order.indexOf(k) < 0; }).sort();
    return known.concat(extra);
  }

  function mechMatsFor(system) {
    return (system === 'vert' ? ['vert'] : ['steel', 'alu']).filter(function (m) {
      return CAT.mech[m] && Object.keys(CAT.mech[m]).length;
    });
  }
  function mechColorsFor(mat) {
    return ordered(Object.keys(CAT.mech[mat] || {}), MECH_COLOR_ORDER);
  }
  function slatMats() {
    return ['wood', 'alu'].filter(function (m) { return CAT.slat[m] && Object.keys(CAT.slat[m]).length; });
  }
  function slatColorsFor(mat) {
    return ordered(Object.keys(CAT.slat[mat] || {}), SLAT_COLOR_ORDER);
  }
  function slatLengthsFor(mat, color) {
    var byLen = (CAT.slat[mat] || {})[color] || {};
    return Object.keys(byLen).map(Number).sort(function (a, b) { return a - b; });
  }

  var HAS_CATALOG = mechMatsFor('flex').length + mechMatsFor('vert').length > 0 && slatMats().length > 0;

  /* ---------------------------------------------------------------
   * Stan
   * --------------------------------------------------------------- */
  var d = FEED.defaults || {};
  var startLang = String(FEED.locale || '').toLowerCase().slice(0, 2);
  if (!T[startLang]) startLang = 'de';

  var state = {
    lang: startLang,
    system: d.system === 'vert' ? 'vert' : 'flex',
    width: d.width || 240,
    height: d.height || 214,
    slatLength: 120,
    mechMat: 'steel',
    mechColor: 'anthracite',
    slatMat: 'wood',
    slatColor: 'natur',
    tilt: typeof d.tilt === 'number' ? d.tilt : 20,
    added: false,
    busy: false,
    error: '',
    touched: false
  };

  // dociąga stan do tego, co realnie jest w katalogu
  function normalize() {
    var mats = mechMatsFor(state.system);
    if (mats.length && mats.indexOf(state.mechMat) < 0) state.mechMat = mats[0];
    var mcols = mechColorsFor(state.mechMat);
    if (mcols.length && mcols.indexOf(state.mechColor) < 0) state.mechColor = mcols[0];

    var smats = slatMats();
    if (smats.length && smats.indexOf(state.slatMat) < 0) state.slatMat = smats[0];
    var scols = slatColorsFor(state.slatMat);
    if (scols.length && scols.indexOf(state.slatColor) < 0) state.slatColor = scols[0];

    var lens = slatLengthsFor(state.slatMat, state.slatColor);
    if (lens.length && lens.indexOf(Number(state.slatLength)) < 0) {
      // najbliższa dostępna długość względem dotychczasowego wyboru
      var want = Number(state.slatLength) || 120;
      state.slatLength = lens.reduce(function (best, L) {
        return Math.abs(L - want) < Math.abs(best - want) ? L : best;
      }, lens[0]);
    }
  }
  normalize();

  /* ---------------------------------------------------------------
   * Pomocnicze
   * --------------------------------------------------------------- */
  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

  var LOCALE_TAG = { pl: 'pl-PL', de: 'de-DE', en: 'en-IE', fr: 'fr-FR', it: 'it-IT', es: 'es-ES' };
  function money(cents) {
    return new Intl.NumberFormat(LOCALE_TAG[state.lang] || 'de-DE', {
      style: 'currency', currency: FEED.currency || 'EUR'
    }).format(cents / 100);
  }

  function el(tag, style, children) {
    var n = document.createElement(tag);
    if (style) for (var k in style) n.style[k] = style[k];
    (children || []).forEach(function (c) {
      if (c == null) return;
      n.appendChild(typeof c === 'string' || typeof c === 'number' ? document.createTextNode(String(c)) : c);
    });
    return n;
  }

  function fill(node, children) {
    if (!node) return;
    node.textContent = '';
    (children || []).forEach(function (c) { if (c != null) node.appendChild(c); });
  }

  function q(sel) { return ROOT.querySelector(sel); }

  /* ---------------------------------------------------------------
   * Pomiar → GA4
   * Sklep ma gtag załadowany przez kanał Google & YouTube, więc wołamy go
   * wprost — te same sesja i stan zgód, co reszta ruchu. Żaden pixel
   * niestandardowy nie jest potrzebny.
   * Równolegle publikujemy zdarzenie przez Shopify.analytics.publish, żeby
   * dało się je kiedyś podpiąć pod pixel niestandardowy bez zmian w kodzie.
   * --------------------------------------------------------------- */
  var TRACK_ON = FEED.track !== false;
  var GA4_ID = FEED.ga4 || '';

  function track(name, payload) {
    if (!TRACK_ON) return;
    var data = payload || {};
    if (GA4_ID) data.send_to = GA4_ID;   // ogranicz do jednej usługi GA4
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
    } catch (e) { /* pomiar nigdy nie może wywrócić konfiguratora */ }
    try {
      var S = window.Shopify;
      if (S && S.analytics && typeof S.analytics.publish === 'function') {
        S.analytics.publish(name, payload || {});
      }
    } catch (e) { /* j.w. */ }
  }

  function payloadFor(c) {
    return {
      currency: FEED.currency || 'EUR',
      value: Math.round(c.total) / 100,
      fw_system: c.isVert ? 'vert' : 'flex',
      fw_opening: c.width + 'x' + c.height,
      fw_built: Math.round(c.builtW) + 'x' + Math.round(c.builtH),
      fw_slat_material: state.slatMat,
      fw_slat_colour: state.slatColor,
      fw_slat_length: c.slatLength,
      fw_mech_material: state.mechMat,
      fw_mech_colour: state.mechColor,
      fw_mech_count: c.mechCount,
      fw_slat_count: c.slatCount
    };
  }

  var blockedSeen = {};

  // „zaczął konfigurować" — celowo bez suwaka nachylenia, który jest zabawką,
  // a nie decyzją zakupową
  function markChanged() {
    if (state.touched) return;
    state.touched = true;
    track('fw_changed', payloadFor(compute()));
  }

  /* ---------------------------------------------------------------
   * Obliczenia — ilości i geometria
   * --------------------------------------------------------------- */
  function compute() {
    var isVert = state.system === 'vert';
    var width = clamp(parseInt(state.width, 10) || 60, 60, 1200);
    var height = clamp(parseFloat(state.height) || 60, 60, 600);

    var LENS = slatLengthsFor(state.slatMat, state.slatColor);
    var slatLength = LENS.indexOf(Number(state.slatLength)) >= 0 ? Number(state.slatLength) : (LENS[0] || 120);

    var pitch = PITCH[isVert ? 'vert' : 'flex'];

    // span = oś, wzdłuż której liczone są lamele; run = oś długości lameli
    var span = isVert ? width : height;
    var run = isVert ? height : width;

    // podział osi "run" na przęsła — resztka dobierana z realnie dostępnych długości
    function upTo(x) {
      var fit = LENS.filter(function (L) { return L >= x; });
      return fit.length ? fit[0] : (LENS[LENS.length - 1] || slatLength);
    }
    var bayLengths = [];
    var full = Math.floor(run / slatLength);
    for (var i = 0; i < full; i++) bayLengths.push(slatLength);
    var rem = run - full * slatLength;
    if (rem > 0.5) bayLengths.push(upTo(rem));
    if (bayLengths.length === 0) bayLengths.push(upTo(run));
    var numBays = bayLengths.length;

    // tabela kończy się na 36 lamelach — powyżej ekstrapolacja średnią podziałką
    var LAST = pitch.length - 1;
    var STEP = (pitch[LAST] - pitch[1]) / (LAST - 1);
    function spanFor(n) { return n <= LAST ? pitch[n] : pitch[LAST] + (n - LAST) * STEP; }
    function slatsForSpan(S) {
      if (S < pitch[1]) return 1;
      if (S >= pitch[LAST]) return LAST + Math.floor((S - pitch[LAST]) / STEP);
      var n = 1;
      for (var k = 1; k <= LAST; k++) { if (pitch[k] <= S) n = k; else break; }
      return n;
    }

    var totalSlats = slatsForSpan(span);
    var mechsV = Math.ceil(totalSlats / CAP);
    var sectionSlats = [];
    var remS = totalSlats;
    for (var r = 0; r < mechsV; r++) { var cc = Math.min(CAP, remS); sectionSlats.push(cc); remS -= cc; }

    var builtRun = bayLengths.reduce(function (a, b) { return a + b; }, 0);
    var builtSpan = spanFor(totalSlats);

    var mechCount = numBays * mechsV;
    var lenCounts = {};
    bayLengths.forEach(function (L) { lenCounts[L] = (lenCounts[L] || 0) + totalSlats; });

    // ---- ceny wyłącznie z wariantów Shopify ----
    var missing = [];
    var lines = [];
    var total = 0;

    var mechVar = (CAT.mech[state.mechMat] || {})[state.mechColor];
    if (mechVar) {
      total += mechVar.price * mechCount;
      lines.push({ variant: mechVar, qty: mechCount });
    } else {
      missing.push('mech ' + state.mechMat + '/' + state.mechColor);
    }

    Object.keys(lenCounts).map(Number).sort(function (a, b) { return b - a; }).forEach(function (L) {
      var v = ((CAT.slat[state.slatMat] || {})[state.slatColor] || {})[L];
      if (v) {
        total += v.price * lenCounts[L];
        lines.push({ variant: v, qty: lenCounts[L] });
      } else {
        missing.push(state.slatMat + '/' + state.slatColor + '/' + L + ' cm');
      }
    });

    var unavailable = lines.filter(function (l) { return l.variant.available === false; })
      .map(function (l) { return l.variant.title; });

    return {
      isVert: isVert, width: width, height: height, slatLength: slatLength, lens: LENS,
      bayLengths: bayLengths, numBays: numBays, totalSlats: totalSlats,
      mechsV: mechsV, sectionSlats: sectionSlats, mechCount: mechCount,
      slatCount: numBays * totalSlats, lenCounts: lenCounts,
      builtW: isVert ? builtSpan : builtRun,
      builtH: isVert ? builtRun : builtSpan,
      areaM2: (width / 100) * (height / 100),
      lines: lines, total: total, missing: missing, unavailable: unavailable
    };
  }

  /* ---------------------------------------------------------------
   * Podgląd 3D
   * --------------------------------------------------------------- */
  function buildVisual(c) {
    var isVert = c.isVert;

    // podgląd dopasowuje się do realnego kontenera — na telefonie jest on
    // znacznie niższy niż 340px, a sztywny rozmiar był przycinany przez overflow
    var host = q('[data-fw-visual]');
    var maxW = Math.min(440, (host && host.clientWidth) || 440);
    var maxH = Math.min(340, (host && host.clientHeight) || 340);

    var ar = c.builtW / c.builtH, fw, fh;
    if (maxW / maxH > ar) { fh = maxH; fw = maxH * ar; } else { fw = maxW; fh = maxW / ar; }
    fw = Math.round(fw); fh = Math.round(fh);

    var spanPx = isVert ? fw : fh;
    var runPx = isVert ? fh : fw;

    var sc = SLAT_COLORS[state.slatColor] || SLAT_COLORS.natur;
    var shadeDeg = isVert ? 90 : 180;
    var grainDeg = isVert ? 0 : 90;
    var slatBg = state.slatMat === 'wood'
      ? 'linear-gradient(' + shadeDeg + 'deg, rgba(255,255,255,.28), rgba(0,0,0,.22)), repeating-linear-gradient(' + grainDeg + 'deg, ' + sc.base + ' 0, ' + sc.base + ' 7px, ' + sc.grain + ' 7px, ' + sc.grain + ' 8px)'
      : 'linear-gradient(' + shadeDeg + 'deg, rgba(255,255,255,.55) 0%, ' + sc.base + ' 38%, ' + sc.base + ' 62%, rgba(0,0,0,.32) 100%)';
    var slatShadow = isVert ? '2px 0 3px -1px rgba(0,0,0,.4)' : '0 2px 3px -1px rgba(0,0,0,.4)';

    var mc = MECH_COLORS[state.mechColor] || MECH_COLORS.anthracite;
    var mechBg = 'linear-gradient(' + (isVert ? 180 : 90) + 'deg, ' + mc.hi + ' 0%, ' + mc.base + ' 28%, ' + mc.base + ' 64%, ' + mc.lo + ' 100%)';

    var railT = clamp(runPx * 0.03, 4, 15);

    // przy małym podglądzie albo dużej liczbie lameli przerwy trzeba ścieśnić,
    // inaczej sama suma odstępów przekracza wysokość kontenera
    var seam = clamp(spanPx * 0.03, 3, 10);
    var totalGaps = Math.max(0, c.totalSlats - c.mechsV);
    function thickFor(g) { return (spanPx - seam * (c.mechsV - 1) - g * totalGaps) / c.totalSlats; }
    var sGap = 2;
    if (thickFor(sGap) < 3) sGap = 1;
    if (thickFor(sGap) < 2) sGap = 0;
    var slatThick = Math.max(1.5, thickFor(sGap));
    function sectionExtent(n) { return n * slatThick + sGap * Math.max(0, n - 1); }

    var tiltTf = isVert ? 'rotateY(' + state.tilt + 'deg)' : 'rotateX(' + state.tilt + 'deg)';
    var tiltOrigin = isVert ? 'left center' : 'center top';

    function railNode(withHandle) {
      var kids = [];
      if (withHandle) {
        kids.push(el('span', {
          position: 'absolute', left: '50%', top: isVert ? '50%' : '78%', transform: 'translate(-50%,-50%)',
          width: Math.max(4, railT * 0.55) + 'px', height: Math.max(4, railT * 0.55) + 'px', borderRadius: '50%',
          background: 'rgba(255,255,255,.55)', boxShadow: '0 0 0 1px rgba(0,0,0,.25)'
        }));
      }
      return el('div', {
        flex: '0 0 ' + railT + 'px', alignSelf: 'stretch', background: mechBg, borderRadius: '3px',
        position: 'relative', boxShadow: '0 0 0 1px rgba(0,0,0,.10),0 6px 14px -6px rgba(0,0,0,.5)', zIndex: '3'
      }, kids);
    }

    function bayNode(len, n) {
      var slats = [];
      for (var i = 0; i < n; i++) {
        var st = {
          borderRadius: '3px', background: slatBg, boxShadow: slatShadow, transform: tiltTf,
          transformOrigin: tiltOrigin, transition: 'transform .5s cubic-bezier(.4,0,.2,1)'
        };
        if (isVert) { st.width = slatThick + 'px'; st.alignSelf = 'stretch'; } else { st.height = slatThick + 'px'; }
        var s = el('div', st);
        s.setAttribute('data-slat', '1');
        slats.push(s);
      }
      return el('div', {
        flex: len + ' ' + len + ' 0', minWidth: '0', minHeight: '0', display: 'flex',
        flexDirection: isVert ? 'row' : 'column', gap: sGap + 'px', transformStyle: 'preserve-3d'
      }, slats);
    }

    function sectionEl(r) {
      var n = c.sectionSlats[r];
      var showHandle = !isVert; // VERT jest bezrączkowy
      var kids = [railNode(showHandle)];
      c.bayLengths.forEach(function (len, bi) {
        kids.push(bayNode(len, n));
        kids.push(railNode(showHandle && bi === c.bayLengths.length - 1));
      });
      var st = { display: 'flex', alignItems: 'stretch', gap: '0px', flexDirection: isVert ? 'column' : 'row' };
      if (isVert) st.width = sectionExtent(n) + 'px'; else st.height = sectionExtent(n) + 'px';
      return el('div', st, kids);
    }

    var stack = [];
    for (var r = 0; r < c.mechsV; r++) {
      stack.push(sectionEl(r));
      if (r < c.mechsV - 1) {
        var gapSt = { background: 'transparent', zIndex: '4', position: 'relative', pointerEvents: 'none' };
        if (isVert) gapSt.width = seam + 'px'; else gapSt.height = seam + 'px';
        stack.push(el('div', gapSt));
      }
    }

    return el('div', {
      position: 'relative', width: fw + 'px', height: fh + 'px', perspective: '1400px',
      filter: 'drop-shadow(0 22px 26px rgba(0,0,0,.32))', display: 'flex',
      flexDirection: isVert ? 'row' : 'column'
    }, stack);
  }

  function applyTilt() {
    var tf = state.system === 'vert' ? 'rotateY(' + state.tilt + 'deg)' : 'rotateX(' + state.tilt + 'deg)';
    var nodes = ROOT.querySelectorAll('[data-slat]');
    for (var i = 0; i < nodes.length; i++) nodes[i].style.transform = tf;
  }

  /* ---------------------------------------------------------------
   * Kontrolki
   * --------------------------------------------------------------- */
  function segStyle(active) {
    return {
      flex: '1', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px',
      padding: '12px 8px', borderRadius: '11px', border: '1.5px solid ' + (active ? '#2f5d4c' : '#e0dcd2'),
      background: active ? '#eef5f1' : '#fff', color: active ? '#1f1d19' : '#5c574e', transition: 'all .15s'
    };
  }
  function chipStyle(active) {
    return {
      cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '7px', padding: '7px 12px 7px 8px',
      borderRadius: '999px', border: '1.5px solid ' + (active ? '#2f5d4c' : '#e6e2d8'),
      background: active ? '#eef5f1' : '#fff', color: '#1f1d19', transition: 'all .15s'
    };
  }

  function mkSeg(label, sub, active, onClick) {
    var b = el('button', segStyle(active), [
      el('span', { fontWeight: '700', fontSize: '14px' }, [label]),
      el('span', { fontSize: '12px', opacity: '.7' }, [sub])
    ]);
    b.type = 'button';
    b.addEventListener('click', onClick);
    return b;
  }

  function mkChip(label, col, active, onClick) {
    var sw = el('span', {
      width: '18px', height: '18px', borderRadius: '50%', background: col, display: 'inline-block',
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.12)' + (active ? ',0 0 0 2px #2f5d4c' : '')
    });
    var b = el('button', chipStyle(active), [sw, el('span', { fontSize: '11px', fontWeight: '600' }, [label])]);
    b.type = 'button';
    b.title = label;
    b.addEventListener('click', onClick);
    return b;
  }

  function sysIcon(vertical, active) {
    var bars = [];
    for (var i = 0; i < 4; i++) {
      var st = { background: active ? '#2f5d4c' : '#b9b4a8', borderRadius: '2px', display: 'block' };
      if (vertical) { st.width = '4px'; st.height = '26px'; } else { st.width = '26px'; st.height = '4px'; }
      bars.push(el('span', st));
    }
    return el('span', { display: 'flex', flexDirection: vertical ? 'row' : 'column', gap: '4px', marginBottom: '4px' }, bars);
  }

  function mkSys(key, label, sub, vertical) {
    var active = state.system === key;
    var b = el('button', segStyle(active), [
      sysIcon(vertical, active),
      el('span', { fontWeight: '700', fontSize: '13.5px' }, [label]),
      el('span', { fontSize: '11.5px', opacity: '.7' }, [sub])
    ]);
    b.type = 'button';
    b.addEventListener('click', function () { setSystem(key); });
    return b;
  }

  function mkLen(v, current) {
    var active = current === v;
    var b = el('button', {
      cursor: 'pointer', padding: '8px 14px', borderRadius: '9px', fontSize: '13px', fontWeight: '600',
      border: '1.5px solid ' + (active ? '#2f5d4c' : '#e0dcd2'),
      background: active ? '#2f5d4c' : '#fff', color: active ? '#fff' : '#5c574e', transition: 'all .15s'
    }, [v + ' cm']);
    b.type = 'button';
    b.addEventListener('click', function () { pick('slatLength', v); });
    return b;
  }

  function mkPill(l, txt) {
    var active = state.lang === l;
    var b = el('button', {
      border: 'none', cursor: 'pointer', fontWeight: '700', fontSize: '13px', padding: '0 15px',
      minHeight: '40px', display: 'inline-flex', alignItems: 'center', // cel dotykowy
      borderRadius: '999px', background: active ? '#1f1d19' : 'transparent', color: active ? '#fff' : '#8a857a', transition: 'all .15s'
    }, [txt]);
    b.type = 'button';
    b.addEventListener('click', function () { state.lang = l; render(); });
    return b;
  }

  function summaryRow(label, value, color) {
    return el('div', { display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13.5px', gap: '12px' }, [
      el('span', { color: '#8a857a' }, [label]),
      el('span', { fontWeight: '600', textAlign: 'right', color: color || 'inherit' }, [value])
    ]);
  }

  /* ---------------------------------------------------------------
   * Akcje
   * --------------------------------------------------------------- */
  function pick(key, value) {
    markChanged();
    state[key] = value;
    state.added = false; state.error = '';
    normalize();
    render();
  }

  function setSystem(sys) {
    if (state.system === sys) return;
    markChanged();
    state.system = sys;
    state.added = false; state.error = '';

    // VERT: lamela pionowa ma przejść przez całą wysokość jednym kawałkiem.
    // Drewno kończy się w katalogu na 120 cm, więc przy typowych wysokościach
    // tarasu jedynym materiałem, który to potrafi, jest aluminium (do 240 cm).
    // Bez tego konfigurator kafelkował wysokość na pasy — 214 cm wychodziło
    // jako 120 + 100, czyli lamela pocięta na dwie części.
    if (sys === 'vert' && CAT.slat.alu) state.slatMat = 'alu';
    normalize();   // dociąga kolor do materiału, zanim wybierzemy długość

    // najkrótsza długość, która pokrywa oś biegu lameli jednym kawałkiem
    // (VERT: wysokość, FLEX: szerokość); gdy żadna nie starcza — najdłuższa
    var run = sys === 'vert' ? (parseFloat(state.height) || 214) : (parseFloat(state.width) || 240);
    var lens = slatLengthsFor(state.slatMat, state.slatColor);
    var fit = lens.filter(function (L) { return L >= run; });
    state.slatLength = fit.length ? fit[0] : (lens[lens.length - 1] || state.slatLength);

    normalize();
    render();
  }

  // Szuflada/powiadomienie koszyka motywu, o ile wystawia API Dawn.
  // Preferujemy szufladę — w Wonder.v2 oba elementy są w DOM, ale aktywna jest szuflada.
  function cartUiElement() {
    var kandydaci = [document.querySelector('cart-drawer'), document.querySelector('cart-notification')];
    for (var i = 0; i < kandydaci.length; i++) {
      var el = kandydaci[i];
      if (el && typeof el.getSectionsToRender === 'function' && typeof el.renderContents === 'function') return el;
    }
    return null;
  }

  function addToCart(c) {
    if (state.busy || c.missing.length || c.unavailable.length || !c.lines.length) return;
    state.busy = true; state.error = '';
    render();

    var cfgId = 'FW-' + Date.now().toString(36).toUpperCase();
    var L = T[state.lang];
    var visible = {};
    visible[L.s0] = c.isVert ? 'FLEX-WOOD® VERT' : 'FLEX-WOOD®';
    visible[L.s1] = c.width + ' × ' + c.height + ' cm';
    visible[L.slatLen] = c.slatLength + ' cm';

    var merged = {};
    c.lines.forEach(function (l) { merged[l.variant.id] = (merged[l.variant.id] || 0) + l.qty; });

    var items = Object.keys(merged).map(function (id) {
      var props = { _fw_config: cfgId };
      for (var k in visible) props[k] = visible[k];
      return { id: Number(id), quantity: merged[id], properties: props };
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Motywy z rodziny Dawn (tu: Wonder.v2) odświeżają szufladę i licznik koszyka
    // przez Section Rendering API. Bez tego pozycja ląduje w koszyku, ale ikona
    // w nagłówku pokazuje stary stan aż do przeładowania strony.
    var cartUi = cartUiElement();
    var payload = { items: items };
    if (cartUi) {
      payload.sections = cartUi.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        state.busy = false;
        if (!res.ok) {
          state.error = (res.body && (res.body.description || res.body.message)) || 'HTTP error';
          render();
          return;
        }
        state.added = true;
        render();

        // oddaj sterowanie motywowi: przerysuj szufladę i licznik jego własnym kodem
        if (cartUi && res.body && res.body.sections) {
          try {
            Array.prototype.slice.call(cartUi.classList).forEach(function (c) {
              if (/(^|-)is-empty$|--empty$/.test(c)) cartUi.classList.remove(c);
            });
            cartUi.renderContents(res.body);
          } catch (e) {
            if (window.console) console.warn('[flex-wood] motyw nie przyjął odświeżenia koszyka:', e);
          }
        }

        // JEDNO zdarzenie na zestaw. Shopify i tak wyśle własne product_added_to_cart
        // osobno dla mechanizmów i lameli — dopiero to poniżej opisuje konfigurację.
        var tp = payloadFor(c);
        tp.fw_config_id = cfgId;
        tp.fw_lines = items.length;
        track('fw_add_to_cart', tp);

        document.dispatchEvent(new CustomEvent('fw:cart:added', { detail: { items: items, configId: cfgId } }));
        if (ROOT.getAttribute('data-redirect') === 'true') window.location.href = root + 'cart';
      })
      .catch(function (err) {
        state.busy = false;
        state.error = String(err && err.message ? err.message : err);
        render();
      });
  }

  /* ---------------------------------------------------------------
   * Render
   * --------------------------------------------------------------- */
  function render() {
    var L = T[state.lang];
    var c = compute();

    var labels = ROOT.querySelectorAll('[data-fw-t]');
    for (var i = 0; i < labels.length; i++) {
      var key = labels[i].getAttribute('data-fw-t');
      if (L[key] != null) labels[i].textContent = L[key];
    }

    var langBox = q('[data-fw-lang]');
        if (langBox) fill(langBox, [mkPill('de', 'DE'), mkPill('pl', 'PL'), mkPill('en', 'EN'),
                                mkPill('fr', 'FR'), mkPill('it', 'IT'), mkPill('es', 'ES')]);

    // system
    fill(q('[data-fw-sys]'), [
      mkSys('flex', L.sysFlex, L.sysFlexSub, false),
      mkSys('vert', L.sysVert, L.sysVertSub, true)
    ]);
    q('[data-fw-syshint]').textContent = c.isVert ? L.hintVert : L.hintFlex;

    // długości lameli — tylko te, które realnie istnieją w wybranym kolorze
    fill(q('[data-fw-len]'), c.lens.map(function (v) { return mkLen(v, c.slatLength); }));
    q('[data-fw-lenval]').textContent = c.slatLength + ' cm';
    q('[data-fw-lenhint]').textContent = c.lens.length < 2
      ? L.oneLen
      : (c.isVert ? L.lenHintVert : L.lenHintFlex);

    // mechanizm
    var mechMats = mechMatsFor(state.system);
    var MECH_LABEL = { steel: L.steel, alu: L.alu, vert: L.vert };
    fill(q('[data-fw-mech]'), mechMats.map(function (mat) {
      var v = (CAT.mech[mat] || {})[state.mechColor] || (CAT.mech[mat] || {})[mechColorsFor(mat)[0]];
      var sub = (v ? money(v.price) : '—') + ' · ' + (mat === 'vert' ? L.noHandle : L.withHandle);
      return mkSeg(MECH_LABEL[mat] || mat, sub, state.mechMat === mat, function () { pick('mechMat', mat); });
    }));
    fill(q('[data-fw-mechcolor]'), mechColorsFor(state.mechMat).map(function (k) {
      return mkChip(L.colors[k] || k, (MECH_COLORS[k] || {}).base || '#999', state.mechColor === k, function () { pick('mechColor', k); });
    }));

    // lamele
    var SLAT_LABEL = { wood: L.wood, alu: L.aluS };
    fill(q('[data-fw-slatmat]'), slatMats().map(function (mat) {
      var cols = slatColorsFor(mat);
      var col = cols.indexOf(state.slatColor) >= 0 ? state.slatColor : cols[0];
      var lens = slatLengthsFor(mat, col);
      // gdy dana długość nie istnieje w tym materiale, pokaż cenę najbliższej
      var len = lens.indexOf(c.slatLength) >= 0 ? c.slatLength : lens.reduce(function (best, L) {
        return Math.abs(L - c.slatLength) < Math.abs(best - c.slatLength) ? L : best;
      }, lens[0]);
      var v = ((CAT.slat[mat] || {})[col] || {})[len];
      return mkSeg(SLAT_LABEL[mat] || mat, (v ? money(v.price) : '—') + ' / ' + L.per, state.slatMat === mat, function () { pick('slatMat', mat); });
    }));
    fill(q('[data-fw-slatcolor]'), slatColorsFor(state.slatMat).map(function (k) {
      return mkChip(L.colors[k] || k, (SLAT_COLORS[k] || {}).base || '#999', state.slatColor === k, function () { pick('slatColor', k); });
    }));

    // podgląd + plakietki
    fill(q('[data-fw-visual]'), [buildVisual(c)]);
    function badge(text, bg, fg) {
      return el('div', {
        background: bg, color: fg, fontSize: '12px', fontWeight: '600', padding: '5px 12px',
        borderRadius: '999px', letterSpacing: '.3px'
      }, [text]);
    }
    fill(q('[data-fw-badges]'), [
      badge(c.width + ' × ' + c.height + ' cm', 'rgba(31,29,25,.85)', '#fff'),
      badge(c.slatCount + ' × lam · ' + c.mechCount + ' × mech', 'rgba(47,93,76,.92)', '#fff'),
      badge(c.isVert ? 'VERT' : 'FLEX-WOOD', c.isVert ? 'rgba(205,191,156,.95)' : 'rgba(255,255,255,.9)', '#1f1d19')
    ]);

    // podsumowanie
    var slatSummary = Object.keys(c.lenCounts).map(Number).sort(function (a, b) { return b - a; })
      .map(function (len) { return c.lenCounts[len] + ' × ' + len + ' cm'; }).join('   +   ');
    // lamele nie są cięte na wymiar — pokazujemy realny wymiar zabudowy
    function cm(n) { return (Math.round(n * 10) / 10).toString().replace('.', state.lang === 'en' ? '.' : ','); }
    var offBy = Math.abs(c.builtW - c.width) > 0.5 || Math.abs(c.builtH - c.height) > 0.5;
    var builtRow = summaryRow(L.built, cm(c.builtW) + ' × ' + cm(c.builtH) + ' cm', offBy ? '#8c5a2b' : null);

    fill(q('[data-fw-summary]'), [
      summaryRow(L.mechs, c.mechCount + ' × ' + (MECH_LABEL[state.mechMat] || state.mechMat)),
      summaryRow(L.slatsN, slatSummary),
      builtRow,
      summaryRow(L.coverage, c.areaM2.toFixed(2).replace('.', state.lang === 'en' ? '.' : ',') + ' m²')
    ]);
    q('[data-fw-total]').textContent = c.missing.length ? '—' : money(c.total);

    // ostrzeżenia
    var warn = q('[data-fw-missing]');
    var problems = [];
    if (!HAS_CATALOG) problems.push(L.noProducts);
    if (c.missing.length) problems.push(L.missing + ' ' + c.missing.join(', '));
    if (c.unavailable.length) problems.push(L.unavailable + ': ' + c.unavailable.join(', '));
    if (state.error) problems.push(L.cartError + ' ' + state.error);
    warn.textContent = problems.join(' · ');
    warn.hidden = problems.length === 0;

    // Utracona konwersja: klient dobrał konfigurację, której nie da się kupić.
    // Liczy się tylko po realnej interakcji i raz na daną kombinację, żeby
    // przeklikiwanie kolorów nie zawyżało statystyki.
    if (state.touched && (c.missing.length || c.unavailable.length)) {
      var sig = [state.system, state.mechMat, state.mechColor, state.slatMat,
        state.slatColor, c.slatLength, c.width, c.height].join('|');
      if (!blockedSeen[sig]) {
        blockedSeen[sig] = true;
        var bp = payloadFor(c);
        bp.fw_reason = c.missing.length ? 'missing_variant' : 'out_of_stock';
        bp.fw_detail = (c.missing.length ? c.missing : c.unavailable).join(', ').slice(0, 100);
        track('fw_blocked', bp);
      }
    }

    // koszyk
    var cart = q('[data-fw-cart]');
    var blocked = !!c.missing.length || !!c.unavailable.length || !HAS_CATALOG;
    cart.textContent = state.busy ? L.adding : state.added ? L.added : L.addToCart;
    cart.disabled = blocked || state.busy;
    cart.style.opacity = blocked ? '.45' : '1';
    cart.style.cursor = blocked ? 'not-allowed' : 'pointer';
    cart.style.background = state.added ? '#2f5d4c' : '#cdbf9c';
    cart.style.color = state.added ? '#fff' : '#1f1d19';
    cart.onclick = function () { addToCart(compute()); };

    q('[data-fw-toggle]').textContent = state.tilt >= 45 ? L.openClose[1] : L.openClose[0];
  }

  /* ---------------------------------------------------------------
   * Pola nieprzebudowywane (żeby nie tracić focusu)
   * --------------------------------------------------------------- */
  function bindNumber(sel, key, lo, hi, parse) {
    var input = q(sel);
    input.addEventListener('input', function () { markChanged(); state[key] = input.value; state.added = false; render(); });
    input.addEventListener('blur', function () {
      var n = parse(input.value);
      state[key] = isNaN(n) ? lo : clamp(n, lo, hi);
      input.value = state[key];
      render();
    });
  }

  bindNumber('[data-fw-width]', 'width', 60, 1200, function (v) { return parseInt(v, 10); });
  bindNumber('[data-fw-height]', 'height', 60, 600, function (v) { return parseFloat(v); });

  var tiltInput = q('[data-fw-tilt]');
  function syncToggleLabel() {
    q('[data-fw-toggle]').textContent = T[state.lang].openClose[state.tilt >= 45 ? 1 : 0];
  }
  tiltInput.addEventListener('input', function () {
    state.tilt = parseInt(tiltInput.value, 10) || 0;
    applyTilt(); syncToggleLabel();
  });
  q('[data-fw-toggle]').addEventListener('click', function () {
    state.tilt = state.tilt >= 45 ? 12 : 70;
    tiltInput.value = state.tilt;
    applyTilt(); syncToggleLabel();
  });

  // Podgląd liczy się w pikselach, więc musi być przerysowany, gdy zmieni się
  // kontener: obrót telefonu, zmiana okna, ale też reflow w edytorze motywu czy
  // otwarcie szuflady — dlatego ResizeObserver, a nie samo zdarzenie 'resize'.
  var redrawTimer = null, lastW = 0, lastH = 0;
  function redrawVisual() {
    var host = q('[data-fw-visual]');
    if (!host) return;
    var w = host.clientWidth, h = host.clientHeight;
    if (w === lastW && h === lastH) return;
    lastW = w; lastH = h;
    if (redrawTimer) clearTimeout(redrawTimer);
    redrawTimer = setTimeout(function () { fill(host, [buildVisual(compute())]); }, 120);
  }

  var vizHost = q('[data-fw-visual]');
  var vizObserver = null;
  if (window.ResizeObserver && vizHost) {
    // referencja trzymana świadomie — obserwator bez niej bywa zbierany przez GC
    vizObserver = new window.ResizeObserver(redrawVisual);
    vizObserver.observe(vizHost);
  }
  // pas i szelki: 'resize' łapie obrót ekranu nawet tam, gdzie ResizeObserver
  // nie dostaje wywołań; podwójny strażnik lastW/lastH pilnuje, by nie rysować dwa razy
  if (window.addEventListener) window.addEventListener('resize', redrawVisual);

  if (UNMATCHED && window.console) {
    console.warn('[flex-wood] pominięto ' + UNMATCHED + ' wariantów bez rozpoznanego SKU (B-Ware lub spoza konfiguratora)');
  }

  render();

  // fw_viewed — konfigurator faktycznie pojawił się na ekranie, a nie tylko
  // został wczytany gdzieś na dole strony
  if (TRACK_ON) {
    if (window.IntersectionObserver) {
      var seenObserver = new window.IntersectionObserver(function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            obs.disconnect();
            track('fw_viewed', payloadFor(compute()));
            break;
          }
        }
      }, { threshold: 0.3 });
      seenObserver.observe(ROOT);
    } else {
      track('fw_viewed', payloadFor(compute()));
    }
  }

  // Pierwszy render trafia w układ, który jeszcze się nie ustabilizował (fonty,
  // aspect-ratio karty), więc podgląd bywa policzony pod mniejszy kontener.
  // Dwa spóźnione przeliczenia — strażnik lastW/lastH zignoruje je, gdy nic się nie zmieniło.
  if (typeof setTimeout === 'function') {
    setTimeout(redrawVisual, 0);
    setTimeout(redrawVisual, 350);
  }
})();